/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionSeriesItemDto } from '../../models/lp-inspection-series-item-dto';

export interface LpInspectionControllerGetStat$Params {

/**
 * 기준
 */
  criteria: 'overallScore' | 'fluencyScore' | 'integrityScore' | 'pcc' | 'totalPcc' | 'pwc' | 'pvc' | 'pmlu' | 'pwp';
}

export function lpInspectionControllerGetStat(http: HttpClient, rootUrl: string, params: LpInspectionControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LpInspectionSeriesItemDto>>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerGetStat.PATH, 'get');
  if (params) {
    rb.query('criteria', params.criteria, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LpInspectionSeriesItemDto>>;
    })
  );
}

lpInspectionControllerGetStat.PATH = '/api/lp-inspection/{id}/nd';
